import React from 'react'

import Fields from './Fields'

export default function Params({ action, stepId }) {
  return (
    <Fields
      actionId={action.id}
      stepId={stepId}
      label="Param"
      pluralLabel="Query Params"
      field="params"
    />
  )
}
